module.exports = __webpack_public_path__ + "img/delete.61b6adf1.svg";